import { message } from "antd";
import idiomaApi from "../../api/Alumno/idiomaApi";

export default {
    getIdiomaMe: async () => {
        const response = await idiomaApi.getIdiomasMe();
        if (!response.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
    createIdiomaMe: async (data) => {
        const response = await idiomaApi.createIdiomaMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    editIdiomaMe: async (data) => {
        const response = await idiomaApi.editIdiomaMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    deleteIdiomaMe: async (id) => {
        const response = await idiomaApi.deleteIdiomaMe(id);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    getCatalogos: async () => {
        const response = await idiomaApi.getCatalogos();
        if (!response.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },

}